import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import {
    ApplicationEmptyState
} from 'core/components';
import {PreviewLayout} from 'core/layouts';
import { toPhoneNumber, emailRecipientTypes  } from 'core/utils';
function CorporatePreviewTemplate({ corporatePreviewStore, t }) {
    const {
        item,
        loaderStore,
        rootStore
    } = corporatePreviewStore;
    
    let facilities = item && item.facilities && item.facilities.slice().sort((a, b) => a.name.localeCompare(b.name)).map(facility => {
        return(
            <div key={facility.id}>
                <a onClick={() => rootStore.routerStore.goTo(
                'master.app.main.facility.preview',{ id: facility.id })}>
                    {facility.name}
                </a>
            </div>
        );
    });

    let contactsRows = item && item.corporateContacts != null ? item.corporateContacts.map(contact => {
        return (<tr key={contact.id}>
            <td>
                {contact.name}
            </td>
             <td>
                {contact.lastName}
            </td>
            <td>
                {contact.contactDepartments && contact.contactDepartments.map(cd => cd.name).join(", ")}
            </td>
            <td>
                {toPhoneNumber(contact.phone)}
            </td>
            <td>
                {contact.email}
            </td>
            <td>
                {contact.position}
            </td>
            <td className="type--center">
                <span className={'u-icon u-icon--sml' + ( contact.specialOrders ? ' u-icon--active' : '')}></span>
            </td>
            <td className="u-cursor--default type--left">
                {emailRecipientTypes.map((setting) => {
                    return contact[setting.field] && contact[setting.field] !== '' && <div key={setting.field} className={'status--include is-'  + contact[setting.field]}>{setting.name}</div>
                })}            
            </td>
        </tr>)
    }) : null;

    return (
        <PreviewLayout store={corporatePreviewStore} emptyRenderer={<ApplicationEmptyState />} loading={loaderStore.loading}>
            <div className="row">
                <div className="col col-sml-12 col-lrg-8">
                    <div className="card card--form card--primary card--med">
                        <h3 className="form__title form__title--preview">{item && item.name}</h3>
                        <div className="u-separator--preview">
                            <div className="row">
                                <div className="col col-sml-12 col-lrg-6">
                                    <div className="form__group__label is-preview">{t('CORPORATE.EDIT.SPECIAL_REQUESTS_LABEL')}</div>
                                </div>
                                <div className="col col-sml-12 col-lrg-6 type--whitespace--preline type--break-all">
                                    {item && item.specialRequests}
                                </div>
                            </div>
                        </div>
                        <div className="u-separator--preview">
                            <div className="row">
                                <div className="col col-sml-12 col-lrg-6">
                                    <div className="form__group__label is-preview">{t('CORPORATE.EDIT.SPECIAL_ORDERS_LABEL')}</div>
                                </div>
                                <div className="col col-sml-12 col-lrg-6">
                                    <span className={'' + ( item && item.specialOrders ? 'u-icon u-icon--sml u-icon--active' : '')}></span>
                                </div>
                            </div>
                        </div>
                        <div className="u-separator--preview">
                            <div className="row">
                                <div className="col col-sml-12 col-lrg-6">
                                    <div className="form__group__label is-preview">Approval Required for Extra Supplies</div>
                                </div>
                                <div className="col col-sml-12 col-lrg-6">
                                    <span className={'' + ( item && item.approvalRequiredExtraSupplies ? 'u-icon u-icon--sml u-icon--active' : '')}></span>
                                </div>
                            </div>
                        </div>
                        <div className="u-separator--preview">
                            <div className="row">
                                <div className="col col-sml-12 col-lrg-6">
                                    <div className="form__group__label is-preview">2nd Payor Check Required</div>
                                </div>
                                <div className="col col-sml-12 col-lrg-6">
                                    <span className={'' + ( item && item.requiredSecondPayor ? 'u-icon u-icon--sml u-icon--active' : '')}></span>
                                </div>
                            </div>
                        </div>
                        <div className="u-separator--preview">
                            <div className="row">
                                <div className="col col-sml-12 col-lrg-6">
                                    <div className="form__group__label is-preview">Reporting Interval</div>
                                </div>
                                <div className="col col-sml-12 col-lrg-6">
                                    <span>{ item && item.reportingIntervalType }</span>
                                </div>
                            </div>
                        </div>
                        <div className="u-separator--preview">
                            <div className="row">
                                <div className="col col-sml-12 col-lrg-6">
                                    <div className="form__group__label is-preview">Reporting Instructions</div>
                                </div>
                                <div className="col col-sml-12 col-lrg-6">
                                    <span>{ item && item.reportingInstructions }</span>
                                </div>
                            </div>
                        </div>
                        <div className="u-separator--preview">
                            <div className="row">
                                <div className="col col-sml-12 col-lrg-6">
                                    <div className="form__group__label is-preview">Corporate Notes</div>
                                </div>
                                <div className="col col-sml-12 col-lrg-6 type--whitespace--preline type--break-all">
                                    <span>{ item && item.description }</span>
                                </div>
                            </div>
                        </div>
                        {item && item.corporateContacts.length != 0 &&
                        <div className="u-mar--bottom--med">
                            <h4 className="form__title form__title--preview">Contacts</h4>
                            {contactsRows &&
                            <table className="table--preview u-mar--bottom--med">
                                <thead>
                                    <tr>
                                        <th className="type--left">First Name</th>
                                        <th className="type--left">Last Name</th>
                                        <th className="type--left">Department</th>
                                        <th className="type--left">Phone</th>
                                        <th className="type--left">Email</th>
                                        <th className="type--left">Note</th>
                                        <th className="type--center w--75--px">Special Order</th>
                                        <th className="type--left is-include w--140--px">Include On</th>
                                    </tr>
                                </thead>
                                <tbody>{contactsRows}</tbody>
                            </table>
                            }
                        </div>}   
                        <div>
                            {facilities}
                        </div>
                    </div>
                </div>
            </div>
        </PreviewLayout>
    )
}

CorporatePreviewTemplate.propTypes = {
    corporatePreviewStore: PropTypes.object.isRequired,
    t: PropTypes.func
};

export default defaultTemplate(CorporatePreviewTemplate);
